import Vue from 'vue';

const state = {
  filtersOpened: false,
};

const getters = {};

const actions = {
  TOGGLE_FILTERS_OPENED: function ({ commit, rootState }) {
    commit('SET_FILTERS_OPENED');
  },
  
};

const mutations = {
  SET_FILTERS_OPENED: (state) => {
    state.filtersOpened = state.filtersOpened ? false : true;
  },
 
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
